import {ref, watch} from 'vue'
import {defineStore} from 'pinia'

export const useGameStore = defineStore('game', () => {
    const search = ref("")
    const game = ref([])
    const gameList = ref([])
    const gameList2 = ref([])
    const exchangeGame = ref({id: undefined})
    const oss = ref("")
    const gameType = ref([])
    const latelyGame = ref(JSON.parse(window.localStorage.getItem('latelyGame')) || [])
    const activeGame = ref({})
    const activeServe = ref({})
    const collectList = ref([])
    const serverList = ref([])
    const activeListType = ref(0)
    const collectStatus = ref(0) //单个收藏状态

    const serverConnectStatus = ref(0)

    // const nowTime = ref(moment().date() + "日 " + moment().hours() + ":" + (moment().minute() >= 30 ? "30" : "00"))

    watch(() => [...latelyGame.value], () => {
        window.localStorage.setItem('latelyGame', JSON.stringify(latelyGame.value))
    })
    return {
        search,
        game,
        gameList,
        gameList2,
        exchangeGame,
        oss,
        gameType,
        latelyGame,
        activeGame,
        activeServe,
        collectList,
        serverList,
        activeListType,
        collectStatus,
        serverConnectStatus,
    }
})
